import React, { PureComponent } from 'react'
import styled from 'styled-components/native'

import Logo from '../../../Atoms/Logo'

import Touchable from '../../../Atoms/Touchable'

import theme from '../../../../styles/theme'

const Container = styled(Touchable)`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: ${theme.gutterUnit}px;
  height: ${theme.headerHeight}px;
`
export default class SidebarHeader extends PureComponent {
  handleOnPress = () => this.props.lockScreen()
  render () {
    return (
      <Container onPress={this.handleOnPress}>
        <Logo hideText={this.props.minimised} />
      </Container>
    )
  }
}
